import { toast } from 'sonner';

import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Justification } from '../models/justification';
import { getJustificationEndpoint } from './const';

export const getJustificationhById = async (id: string): Promise<Justification> => {
    try {
        const response = await getHttpClient().get<Justification>({ url: `${getJustificationEndpoint}/${id}` });

        if (response) {
            return response;
        }

        toast.error('Brak danych.');
        throw new Error('No justification data received.');
    } catch (error) {
        toast.error(`Błąd podczas pobierania danych: ${error}`);
        throw error;
    }
};
